import { API_BASE_URL } from "../config/api";
import { apiRequest } from "./http";

export interface LiveClassRecord {
    id: number;
    name: string;
    url?: string;
    class_date: string;
    end_time: string;
    end_date: string;
    timezone: string;
    is_active: boolean;
    plan_ids: number[];
    created_at?: string;
    updated_at?: string;
}

export interface CreateClassPayload {
    name: string;
    url: string;
    class_date: string;
    end_time: string;
    end_date: string;
    timezone: string;
    is_active?: boolean;
    plan_ids: number[];
}

export type UpdateClassPayload = Partial<CreateClassPayload>;

interface ClassesListResponse {
    success: boolean;
    message: string;
    data: LiveClassRecord[];
}

interface ClassMutationResponse {
    success: boolean;
    message: string;
    data: LiveClassRecord;
}

interface ClassJoinResponse {
    success: boolean;
    message: string;
    data: {
        join_path: string;
        expires_in: number;
    };
}

export function getClasses(token: string) {
    return apiRequest<ClassesListResponse>({
        endpoint: "/classes",
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function createClass(token: string, payload: CreateClassPayload) {
    return apiRequest<ClassMutationResponse>({
        endpoint: "/classes",
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });
}

export function updateClass(token: string, classId: number, payload: UpdateClassPayload) {
    return apiRequest<ClassMutationResponse>({
        endpoint: `/classes/${classId}`,
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });
}

export function requestClassJoin(token: string, classId: number) {
    return apiRequest<ClassJoinResponse>({
        endpoint: `/classes/${classId}/join`,
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function buildClassJoinUrl(joinPath: string): string {
    const normalizedPath = joinPath.startsWith("/") ? joinPath : `/${joinPath}`;
    return `${API_BASE_URL}${normalizedPath}`;
}
